module.exports = __webpack_public_path__ + "static/media/before-you-start.3162b5f0.svg";